import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { storyClient } from '../client/storyClient';


export type Params = {
  id: number;
};

type Options = {
};

const defaultOptions: Partial<Options> = {
};

export const useStory = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data: story } = {}, status, error } = useSuspenseQuery({
    queryKey: [cacheKeys.getStory, params.id],
    queryFn: () => storyClient.getStory(params),
  });

  return {
    status,
    error,
    story,
  };
};
